document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector('.bubble-video__overlay');
  document.querySelectorAll('.bubble-video__video').forEach(bubble => {
    bubble.addEventListener('click', function () {
      const videoUrl = this.getAttribute('data-video-url');
      const videoSource = document.querySelector('.bubble-video__popup-source');
      overlay.style.display = 'block';
      videoSource.src = videoUrl;
      const video = document.querySelector('.bubble-video__popup-video');
      video.load();
      video.currentTime = 0;
      video.play();
      document.querySelector('.bubble-video__popup').style.display = 'block';
      document.querySelector('#main').style.position = 'relative';
      document.querySelector('#main').style.zIndex = 5;
    });
  });
  document.querySelectorAll('.bubble-video__popup-close, .bubble-video__overlay').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      overlay.style.display = 'none';
      const video = document.querySelector('.bubble-video__popup-video');
      video.pause();
      video.currentTime = 0;
      document.querySelector('.bubble-video__popup').style.display = 'none';
      document.querySelector('#main').style.position = 'relative';
      document.querySelector('#main').style.zIndex = 4;
    });
  });

  // STICKY ADD TO CART
  let variantPickerOptions = document.querySelectorAll('variant-picker .variant-picker__option-values input');
  let stickyATC = document.querySelector('product-sticky-bar');
  let stickyVariantPickerOptions = stickyATC.querySelectorAll('.product-sticky-bar__variant');
  let mainATCButton = document.querySelector('.product-info__block-item .button');
  handleVariantSelection(variantPickerOptions, stickyVariantPickerOptions, stickyATC);
  document.addEventListener('variant:change', e => {
    let newSelectedOption = e.detail.variant;
    let newSelectedOptionId = newSelectedOption.id;

    // Selected the right option in the sticky bar
    stickyVariantPickerOptions.forEach(option => {
      if (option.getAttribute('data-variant-id') == newSelectedOptionId) {
        updateSelectedOptionInStickyATC(option);

        // Update price(s) in the sticky ATC button
        updatePricesInStickyATC(stickyATC, option);
      }
    });

    // Re-define the variant picker on the product page to simulate clicking on the right variant
    let newVariantPickerOptions = document.querySelectorAll('variant-picker .variant-picker__option-values input');
    handleVariantSelection(newVariantPickerOptions, stickyVariantPickerOptions, stickyATC);

    // Re-define main ATC button
    mainATCButton = document.querySelector('.product-info__block-item .button');
  });

  // Simulate a click on the ATC button when user click on the sticky ATC button
  let stickyATCButton = stickyATC.querySelector('button');
  stickyATCButton.addEventListener('click', () => {
    mainATCButton.click();
  });

  // Display sticky add to cart after the main add to cart button
  let distanceToDisplaySticky;
  if (window.matchMedia("(min-width:768px)").matches) {
    // Desktop
    distanceToDisplaySticky = mainATCButton.offsetTop + 40;
  } else {
    // Mobile
    distanceToDisplaySticky = mainATCButton.offsetTop + 100;
  }
  window.addEventListener('scroll', () => {
    if (window.scrollY > distanceToDisplaySticky) {
      stickyATC.classList.add('is-visible');
    } else {
      stickyATC.classList.remove('is-visible');
    }
  });
});
function updatePricesInStickyATC(stickyATC, option) {
  let stickyATCButton = stickyATC.querySelector('button');

  // Remove old price(s)
  let oldPrice = stickyATCButton.querySelector('.button__price');
  let oldCompareAtPrice = stickyATCButton.querySelector('.button__compare-at-price');
  if (oldPrice) oldPrice.remove();
  if (oldCompareAtPrice) oldCompareAtPrice.remove();

  // Variant price(s)
  let option_price = option.getAttribute('data-variant-price');
  let option_compare_at_price = option.getAttribute('data-variant-compare-at-price');

  // Reinject content in the sticky ATC button :
  let newPrice = document.createElement('p');
  newPrice.classList.add('button__price');
  newPrice.textContent = option_price;
  stickyATCButton.appendChild(newPrice);
  let option_price_float = parseFloat(option_price.replace('€', "").replace(',', '.'));
  let option_compare_at_price_float = parseFloat(option_compare_at_price.replace('€', "").replace(',', '.'));
  // If discounted price is available, display it
  if (option_compare_at_price_float > option_price_float) {
    let newCompareAtPrice = document.createElement('p');
    newCompareAtPrice.classList.add('button__compare-at-price');
    newCompareAtPrice.textContent = option_compare_at_price;
    stickyATCButton.appendChild(newCompareAtPrice);
  }
}
function updateSelectedOptionInStickyATC(option) {
  // Remove selected class from selected option 
  let currentSelectedOption = document.querySelector('.product-sticky-bar__variant.is-selected');
  currentSelectedOption.classList.remove('is-selected');

  // Add selected class to the new selected option
  option.classList.add('is-selected');
}
function handleVariantSelection(variantPickerOptions, stickyVariantPickerOptions, stickyATC) {
  stickyVariantPickerOptions.forEach(option => {
    option.addEventListener('click', () => {
      updateSelectedOptionInStickyATC(option);

      // Update price(s) in the sticky ATC button
      updatePricesInStickyATC(stickyATC, option);

      // Simulate a click on the right variant in the variant picker
      let index = Array.from(stickyVariantPickerOptions).indexOf(option);
      variantPickerOptions[index].click();
    });
  });
}